const pms_use_funds = [
  {
    value: "business",
    name: "Business",
  },
  {
    value: "personal",
    name: "Personal",
  },
  {
    value: "both",
    name: "Both",
  },
];

export default pms_use_funds;



// WEBPACK FOOTER //
// ./src/constants/pms_use_funds.js